import * as Sentry from "@sentry/react";

export function handleException(error) {
  Sentry.captureException(error);
  if (process.env.REACT_APP_NODE_ENV === "development") {
    console.error(error);
  }
}
